/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskPersonResponse
 */
export interface TaskPersonResponse {
    /**
     * 
     * @type {string}
     * @memberof TaskPersonResponse
     */
    personWithRoleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskPersonResponse
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskPersonResponse
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskPersonResponse
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskPersonResponse
     */
    appUserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskPersonResponse
     */
    isRead?: boolean;
}

/**
 * Check if a given object implements the TaskPersonResponse interface.
 */
export function instanceOfTaskPersonResponse(value: object): value is TaskPersonResponse {
    return true;
}

export function TaskPersonResponseFromJSON(json: any): TaskPersonResponse {
    return TaskPersonResponseFromJSONTyped(json, false);
}

export function TaskPersonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskPersonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'personWithRoleId': json['personWithRoleId'] == null ? undefined : json['personWithRoleId'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'birthDate': json['birthDate'] == null ? undefined : json['birthDate'],
        'appUserId': json['appUserId'] == null ? undefined : json['appUserId'],
        'isRead': json['isRead'] == null ? undefined : json['isRead'],
    };
}

export function TaskPersonResponseToJSON(json: any): TaskPersonResponse {
    return TaskPersonResponseToJSONTyped(json, false);
}

export function TaskPersonResponseToJSONTyped(value?: TaskPersonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personWithRoleId': value['personWithRoleId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'birthDate': value['birthDate'],
        'appUserId': value['appUserId'],
        'isRead': value['isRead'],
    };
}

